module.exports = __webpack_public_path__ + "static/venice-1035684_1920-96b5703063c625bcc369b58f3b2c783a.png";